import { render, staticRenderFns } from "./DialogNotif.vue?vue&type=template&id=439f75fa&"
import script from "./DialogNotif.vue?vue&type=script&lang=js&"
export * from "./DialogNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports